import { useTranslation } from '@splitfiesta/i18n';

import { StoreBadge } from '@/components/common/StoreBadge';

interface NativeAppInviteBlockProps {
  store: 'ios' | 'android';
  onContinue: () => void;
}

/**
 * Phone-only "open this invite in the app" step. The join step replaces it
 * once the visitor picks "Continue in the browser"; joining on the web is
 * real membership and the group appears in the app after sign-in.
 */
export function NativeAppInviteBlock({
  store,
  onContinue,
}: NativeAppInviteBlockProps) {
  const { t } = useTranslation('common');

  return (
    <div
      data-testid="native-app-invite"
      className="mb-6 rounded-xl border border-primary-100 bg-primary-50 p-4 text-center dark:border-primary-500/20 dark:bg-primary-500/10"
    >
      <p className="text-sm font-semibold text-gray-900 dark:text-gray-50">
        {t('nativeApp.invite.title')}
      </p>
      <p className="mt-1 text-xs text-gray-600 dark:text-gray-300">
        {t('nativeApp.invite.body')}
      </p>
      <div className="mt-3 flex justify-center">
        <StoreBadge store={store} />
      </div>
      <button
        type="button"
        onClick={onContinue}
        className="mt-3 text-xs font-medium text-primary-600 underline-offset-2 hover:underline dark:text-primary-400"
      >
        {t('nativeApp.invite.continueWeb')}
      </button>
    </div>
  );
}
